import { z } from 'zod';
export const ScopeRuleEffectSchema = z.enum(['admin', 'map']);
export const ScopeRuleSchema = z
    .object({
    id: z.string().uuid(),
    tableId: z.string().uuid(),
    sortOrder: z.number().int(),
    /** 매칭 대상 user attribute key (user_attribute_definitions.key 또는 'email'). */
    attributeKey: z.string().min(1).max(60),
    /** 매칭 값 (정확히 일치). */
    attributeValue: z.string().min(1).max(200),
    effect: ScopeRuleEffectSchema,
    targetAttributeKey: z.string().max(60).nullable(),
    targetTableColumn: z.string().max(120).nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
})
    .refine((v) => v.effect === 'admin' || (v.targetAttributeKey && v.targetTableColumn), {
    message: "effect='map' 인 경우 targetAttributeKey/targetTableColumn 모두 필수",
    path: ['effect'],
});
export const ScopeRuleListSchema = z.object({
    rules: z.array(ScopeRuleSchema),
});
export const CreateScopeRuleRequestSchema = z
    .object({
    attributeKey: z.string().min(1).max(60),
    attributeValue: z.string().min(1).max(200),
    effect: ScopeRuleEffectSchema,
    /** effect='admin' 면 무시됨. */
    targetAttributeKey: z.string().min(1).max(60).optional(),
    targetTableColumn: z.string().min(1).max(120).optional(),
})
    .refine((v) => v.effect === 'admin' || (v.targetAttributeKey && v.targetTableColumn), {
    message: "effect='map' 인 경우 targetAttributeKey/targetTableColumn 모두 필수",
    path: ['effect'],
});
export const UpdateScopeRuleRequestSchema = z.object({
    attributeKey: z.string().min(1).max(60).optional(),
    attributeValue: z.string().min(1).max(200).optional(),
    effect: ScopeRuleEffectSchema.optional(),
    targetAttributeKey: z.string().max(60).nullable().optional(),
    targetTableColumn: z.string().max(120).nullable().optional(),
});
export const ReorderScopeRulesRequestSchema = z.object({
    ids: z.array(z.string().uuid()).min(1).max(50),
});
//# sourceMappingURL=data-source-scope-rules.js.map